// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tDju","rating":"styles_rating__oyANh","title":"styles_title__fGRse","byline":"styles_byline__5ebpy","awardIcon":"styles_awardIcon__eFZBz"};